
import { Time } from '@/model';
import Vue from 'vue';

export default Vue.extend({
  name: 'YearPicker',

  props: {
    value: { type: Number as () => Time | undefined, required: false },
    label: { type: String, default: 'Pick a year' },
    dense: { type: Boolean, default: false },
  },

  data() {
    return {
      editValue: undefined as number | undefined,
      range: { lower: 15, upper: 2 },
    };
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.editValue = this.value ? Time.year(this.value) : undefined;
      },
    },
  },

  computed: {
    years(): number[] {
      const currentYear = Time.year(Time.now());
      const start = currentYear - this.range.lower;
      const end = currentYear + this.range.upper;
      const diff = end - start;
      if (diff === 0) {
        return [start];
      }

      const keys = Array(Math.abs(diff) + 1).keys();
      return Array.from(keys).map((x) => {
        const increment = end > start ? x : -x;
        return start + increment;
      }).reverse();
    },
  },

  methods: {
    input() {
      this.$emit('input', this.editValue ? Time.parseYear(this.editValue) : undefined);
    },
  },
});

